import { render, staticRenderFns } from "./RedDotIcon.vue?vue&type=template&id=6f909a0b"
import script from "./RedDotIcon.vue?vue&type=script&lang=js"
export * from "./RedDotIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports